import React from "react";
import PropTypes from "prop-types";
import "./card-panel.scss";

function CardPanelBody(props) {
	return <div className={`panel-card-body`}>{props.children}</div>;
}

export default CardPanelBody;
CardPanelBody.propTypes = {
	children: PropTypes.node.isRequired,
};
// CardPanel.defaultProps = {
// 	noSpacing: false,
// 	smallSpacing: false,
// 	border: false,
// 	noShadow: false,
// };
